import axios, { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { StrategyData } from '@app/types/plugins';

async function fetcher(strategyIpfsHash: string | undefined) {
  if (!strategyIpfsHash) {
    return null;
  }

  const { data } = await axios.get<void, AxiosResponse<StrategyData>>(
    `https://ipfs.io/ipfs/${strategyIpfsHash}`
  );

  return data;
}

export function useStrategyData(strategyIpfsHash: string | undefined) {
  return useQuery([QueryKeys.STRATEGY_DATA, strategyIpfsHash], () => {
    return fetcher(strategyIpfsHash);
  });
}
